// TODO: Write tests for this file

import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";

import { DynamicDocs, useGetDocsPageRoute } from "./helpers";
import { FederatedModulesDocsPage } from "./DocsPage";

export type FederatedModulesDocsAppRouterProps = {
  dynamicDocs: DynamicDocs[];
};

export const FederatedModulesDocsAppRouter: React.FC<
  FederatedModulesDocsAppRouterProps
> = ({ dynamicDocs }) => {
  const getDocsPageRoute = useGetDocsPageRoute();

  return (
    <Switch>
      {dynamicDocs.map(({ docs, route, docgenResult, propsFile }) => {
        return (
          <Route key={route} path={getDocsPageRoute({ docsPage: route })}>
            <FederatedModulesDocsPage
              docgenResult={docgenResult}
              propsFile={propsFile}
              usageBlocks={docs.usageBlocks}
            />
          </Route>
        );
      })}
      {dynamicDocs.length && (
        <Redirect to={getDocsPageRoute({ docsPage: dynamicDocs[0].route })} />
      )}
    </Switch>
  );
};
